import keyBy from 'lodash/keyBy';
import range from 'lodash/range';
import moment from 'moment';

export function compareMoments(a, b) {
  if (a.isBefore(b)) return -1;
  if (a.isAfter(b)) return 1;
  return 0;
}

export function getSortedMoments(dates) {
  return dates.map(date => moment(date)).sort(compareMoments);
}

function newQuarterlyBudget(year, quarter) {
  return {
    year,
    quarter: quarter.toString(),
    share: 0,
  };
}

export function updateQuarterlyBudgets(quarters, startDate, endDate) {
  if (!startDate || !endDate) return quarters; // No need to change
  const [start, end] = getSortedMoments([startDate, endDate]);

  const existingBudgets = keyBy(quarters, q => `${q.year}-${q.quarter}`);
  const diffQuarters = end
    .endOf('quarter')
    .diff(start.startOf('quarter'), 'quarter');

  // We end up with diffQuarter + 1 shares because the startDate quarter is included
  return range(0, diffQuarters + 1).map(offset => {
    const date = moment(start).add(offset, 'quarter');
    const year = date.year();
    const quarter = date.quarter();
    return (
      existingBudgets[`${year}-${quarter}`] || newQuarterlyBudget(year, quarter)
    );
  });
}
